<template>
  <div
    :class="[
      $style.status,
      { [$style['status--commented']]: hasPlannerCommented },
    ]"
  >
    <IconCheckCircle :class="$style.status__icon" />
    <p :class="$style.status__text">
      {{ plannerCommentedStatusText }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IconCheckCircle from '@/components/icons/IconCheckCircle.vue'

const props = defineProps<{
  hasPlannerCommented: boolean
}>()

const plannerCommentedStatusText = computed(() => {
  return props.hasPlannerCommented ? 'アプローチ済み' : '未アプローチ'
})
</script>

<style lang="scss" module>
.status {
  display: flex;
  align-items: center;
  color: $color-text-and-object-low-emphasis;

  &--commented {
    color: $color-success-object;
  }

  &__icon {
    width: 24px;
    height: 24px;
  }

  &__text {
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}
</style>
